import React from "react";
import CardList from "@/modules/CardList";
import { $t } from './i18n';
// import i18n from 'i18next';

// https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=16990

class Card extends React.Component {
  render() {
    const { message = {}, id } = this.props
    return (
      <section id={id}>
        <h2 className="section-title">{$t(message.title)}</h2>
        <CardList list={message.list} />
      </section>
    );
  }
}

export default Card;
